import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {TargetConfig, TourService} from './tour.service';

@Directive({selector: '[tourStepTarget]'})
export class TourStepTargetDirective implements AfterViewInit, OnDestroy {

  // tslint:disable-next-line:no-input-rename
  @Input('tourStepTarget') config: string | TargetConfig;

  @Output() tourStepComplete = new EventEmitter<string>();

  constructor(private Tour: TourService,
              public elem: ElementRef) {
  }

  ngAfterViewInit() {
    const config = this.getConfig();
    this.Tour.registerStepTarget({...config, component: this});
  }

  ngOnDestroy() {
    this.Tour.deregisterStepTarget(this.getConfig().name, this);
  }

  private getConfig(): TargetConfig {
    return typeof this.config === 'string' ? {name: this.config} : this.config;
  }
}
